import classnames from "classnames";
import classes from "./ContactUs.module.scss";
import ContactUsForm from "./ContactUsForm";
import { offers } from "../../../global/constant";
import { nanoid } from "nanoid";
import Tick from "../../../assets/icons/tick.svg";

function ContactUs({ classname }) {
  return (
    <div
      id="contactUsForm"
      className={classnames(classes.main__container, classname)}
    >
      <div className={classnames(classes.container, "containerWidth")}>
        <div className={classnames(classes.offers)}>
          <div>
            <div className={classnames(classes.heading)}>Contact Us</div>
            <div className={classnames(classes.subheading)}>
              To help us help you, please share your details & we will reach out
              to you!
            </div>
            <div className={classes.gen_inquiry}>
              <h6>Connect with Sales:</h6>
              <a href="tel:080-42547226">080-42547226</a>
            </div>
            <div className={classes.gen_inquiry}>
              <h6>General Inquiries:</h6>
              <a href="mailto:mmasales.north@paytm.com">
                mmasales.north@paytm.com
              </a>
            </div>
          </div>
          <div>
            <div className={classnames(classes.productOffers)}>
              Our product offers:
            </div>
            <ul className={classnames(classes.productOffersList)}>
              {offers.map(offer => {
                return (
                  <li key={nanoid()}>
                    <img src={Tick} alt="Tick" />
                    <span>{offer}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <ContactUsForm className={classnames(classes.formSection)} />
      </div>
    </div>
  );
}
export default ContactUs;
